import { useState, useEffect } from 'react';
import { scheduleModelData } from '../services/ModelService';

export default function useAllCharterSchedules() {
    const [allCharterSchedules, setAllCharterSchedules] = useState(null);

    useEffect(() => {
        const listener = scheduleModelData.addListener({
            setterFn: setAllCharterSchedules, loaded: schedules => {
                setAllCharterSchedules(schedules);
            }
        });

        return () => {
            if (listener) {
                scheduleModelData.removeListener(listener);
            }
        }
    }, []);


    return { allCharterSchedules };
}
